(function () {
  angular
    .module('kareo.walkme-configuration', ['kareo.ui.shared.modules.walkme'])
    .run(initKareoWalkme);

  initKareoWalkme.$inject = ['KareoWalkme'];

  function initKareoWalkme(KareoWalkme) {
    KareoWalkme.initialize();
  }
})();
